import { DateTimeHelper } from "src/app/helpers/datetime";
import { CurrentAssetLocationDto, ContainerStatus } from "src/shared/service-proxies/service-proxies";

export class AssetOnSiteModel {
    id: string;
    assetURL: string;
    daysOnSite: string;
    type: string;
    isIntegration: boolean = false;
    order: string;
    wasteTypeName: string;
    assetTypeClassification: number;
    containerStatus: string;
    statusDisplay: string;

    constructor(data: CurrentAssetLocationDto) {
        this.id = data.id;
        this.assetURL = data.assetURL;
        this.type = data.assetType;
        this.daysOnSite = data.daysAtLocation + " days";
        this.assetTypeClassification = data.assetTypeClassification;
        this.containerStatus = ContainerStatus[data.containerStatus];
        this.statusDisplay = splitByCapitalLetters(ContainerStatus[data.containerStatus])
    }
}

export class GroupedAssetOnSiteModel {
    order: string;
    assetsOnSite: AssetOnSiteModel[] = [];
}

function splitByCapitalLetters(str) {
    return str.replace(/([a-z])([A-Z])/g, '$1 $2');
  }
